import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";
import { LoadRealTimeInventoryOverride } from "@MasterBluePrint/Handlers/LoadProductPricingAndInventory";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainAfter(chain, LoadRealTimeInventoryOverride, async props => {
    try {
        const dataLayer = (window as any).dataLayer || [];

        const product = props?.parameter.product;
        if (product) {
            const checkData = () => {
                return !!props.pricingLoaded && !!props.inventoryLoaded;
            };

            await waitFor(checkData);

            const productInfo = props.getState().pages.productDetails.productInfosById![product.id];
            const location = getLocation(props.getState());
            const path = location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname;
            const catalogPage = getCatalogPageStateByPath(props.getState(), path).value;
            const category = getCategoryState(props.getState(), catalogPage?.categoryId).value;
            const description = product?.productTitle;
            const productNumber = product?.productNumber;
            const brandName = product?.brand?.name;
            const condition = product?.properties?.condition;
            const inventoryAvailability = productInfo?.inventory?.inventoryAvailabilityDtos?.find(
                o => o.unitOfMeasure === productInfo?.unitOfMeasure,
            );
            // Condition to show stock as "DirectShip" when total qty<=0 and isDirectShipFromManufacturer is true
            const stockDetails =
                productInfo?.inventory?.qtyOnHand !== undefined &&
                    productInfo?.inventory?.qtyOnHand <= 0 &&
                    product.properties.isDirectShipFromManufacturer.toLowerCase() === "true"
                    ? "DirectShip"
                    : inventoryAvailability?.availability?.message;

            let vendorStockStatus = "";
            let vendorStockQty = 0;

            if (productInfo?.inventory?.inventoryWarehousesDtos) {
                const warehouseDto = productInfo?.inventory?.inventoryWarehousesDtos[0].warehouseDtos;
                if (warehouseDto) {
                    for (const warehouseData of warehouseDto) {

                        if (warehouseData.name === "Vendor Stock") {
                            // setvendorStockQty(warehouseData.qty);
                            vendorStockQty = warehouseData.qty;
                        }

                        if (warehouseData.qty > 0 && warehouseData.name === "Blind Ship") {
                            // setVendorStockStatus("blindship");
                            vendorStockStatus = "blindship";
                            break;
                        }

                        if (product.properties.isDirectShipFromManufacturer?.toLowerCase() === "false") {
                            if ((warehouseData.qty > 0 && warehouseData.name === "Vendor Stock") || (warehouseData.qty === 0 && warehouseData.name === "Blind Ship")) {
                                // setVendorStockStatus("crossdock");
                                vendorStockStatus = "crossdock";
                                break;
                            }
                        }
                    }
                }
            }

            if (product.properties.isDirectShipFromManufacturer?.toLowerCase() === "true" && vendorStockStatus === "") {
                // setVendorStockStatus("directship");
                vendorStockStatus = "directship";
            }
            const hazardousProduct = product?.detail?.isHazardousGood === true ? "Yes" : "";
            const variantProduct = product?.variantTraits && product.variantTraits.length > 0 ? "Yes" : "";

            dataLayer.push({
                event: "productDetail",
                ecommerce: {
                    detail: {
                        products: [
                            {
                                name: description,
                                category: category?.name ?? "",
                                id: productNumber,
                                price: productInfo?.pricing?.actualPrice,
                                brand: brandName,
                                condition,
                                stock: stockDetails,
                                stockqty: productInfo?.inventory?.qtyOnHand,
                                vendorstockqty: vendorStockQty,
                                vendorstockstatus: vendorStockStatus,
                                Hazardous:hazardousProduct,
                                variantproduct: variantProduct
                            },
                        ],
                    },
                },
            });
        }
    } catch (err) {
        // eslint-disable-next-line no-console
        logger.debug(err);
    }
});
